export class CookieHelper {
  static uriForNextLoadLabel = "uriForNextLoad";
  static isLeftMenuMinimized = "isLeftMenuMinimized";
  static hideCreateDocumentTooltip = "hideCreateDocumentTooltip";
  static hideArchivedSectionsTooltip = "hideArchivedSectionsTooltip";

  // Standard cookie functions
  static getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  static setCookie(name, value, days, hours = 0, minutes = 0) {
    var expires = "";

    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000 + hours * 60 * 60 * 1000 + minutes * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "") + expires + ";path=/;SameSite=Lax";
  }

  static deleteCookie(name) {
    document.cookie = name + "=; Max-Age=-99999999;";
  }

  // Custom cookies
  static setCookieForNextBrowserLoad(uri) {
    this.setCookie(this.uriForNextLoadLabel, uri, 0, 0, 5);
  }

  static getCookieForNextBrowserLoad() {
    return this.getCookie(this.uriForNextLoadLabel);
  }

  static deleteCookieForNextBrowserLoad() {
    this.deleteCookie(this.uriForNextLoadLabel);
  }

  static setCookieForIsLeftMenuMinimized(val) {
    this.setCookie(this.isLeftMenuMinimized, val, 365);
  }

  static getCookieForIsLeftMenuMinimized() {
    return this.getCookie(this.isLeftMenuMinimized);
  }

  static setCookieHideCreateDocumentTooltip(val) {
    this.setCookie(this.hideCreateDocumentTooltip, val, 365);
  }

  static getCookieHideCreateDocumentTooltip() {
    return this.getCookie(this.hideCreateDocumentTooltip);
  }

  static setCookieHideArchivedSectionsTooltip(val) {
    this.setCookie(this.hideArchivedSectionsTooltip, val, 365);
  }

  static getCookieHideArchivedSectionsTooltip() {
    return this.getCookie(this.hideArchivedSectionsTooltip);
  }
}
